import Reuqest from "./request/index";

export const service = new Reuqest({
	// baseURL: process.env.NODE_ENV !== "development" ? "https://api.argos-jpc.com" : "https://api.staging-argos-jpc.com",
	baseURL: "https://api.staging-argos-jpc.com",
	// baseURL: "/api",
	timeout: 120000,
});
